import { currencyInput } from '@/_schemas/generic';
import { defaultNumericIdOption } from '@/_shared';

import type { ProductAndServicesQuerySchema } from '../schemas/products-and-services';

export function productAndServicesQueryEnhancer(data: ProductAndServicesQuerySchema): ProductAndServicesQuerySchema {
  return {
    ...data,
    sku: data?.sku ?? '',
    list_price: currencyInput.formToUpdateConverter(`${data?.list_price ?? 0}`),
    client_opt: data.client_opt,
    price_frequency: data?.price_frequency ?? defaultNumericIdOption(),
    category: { ...data.category, wholesale_discount: parseFloat(`${data?.category?.wholesale_discount || '0'}`) },
    wholesale_price: currencyInput.formToUpdateConverter(`${data?.wholesale_price ?? 0}`),
  };
}
